// Module
var code = `<breadcrumbs></breadcrumbs>
<section class="box">
  <sub-header header="\$ctrl.title"></sub-header>

  <table class="table table--last-column-to-right">
    <thead>
    <tr>
      <th>No</th>
      <th>Report Name</th>
      <th>Actions</th>
    </tr>
    </thead>
    
    <tbody>
    <tr ng-repeat="report in \$ctrl.reports" class="report-list-row table table--last-column-to-right">
      <td>{{(\$index + 1) + '.'}}</td>
      <td>{{report.name}}</td>
      <td>
        <a ng-href="{{\$ctrl.openLink(report)}}" class="btn btn-primary">
          Open
        </a>
      </td>
    </tr>
    
    <tr ng-if="!\$ctrl.reports.length || \$ctrl.reports.length <= 0" class="table__empty-message table__row--not-hoverable">
      <td colspan="3">
        There are no items to show
      </td>
    </tr>
    </tbody>
  </table>

</section>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/report/custom-report/custom-report.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;